export default __webpack_public_path__ + "static/media/5.32d00ee7.jpg";